import React from "react";
import { Plus, Search, Sparkles, RefreshCw } from "lucide-react";

interface TemplatesHeaderProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onCreateTemplate: () => void;
  onShowPreBuilt: () => void;
  onRefresh: () => void;
  templatesCount: number;
  isLoading: boolean;
}

const TemplatesHeader: React.FC<TemplatesHeaderProps> = ({
  searchTerm,
  setSearchTerm,
  onCreateTemplate,
  onShowPreBuilt,
  onRefresh,
  templatesCount,
  isLoading,
}) => {
  return (
    <div className="bg-white shadow rounded-lg p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Email Templates</h1>
          <p className="text-gray-600 mt-1">
            Create and manage your email templates ({templatesCount} total)
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          {/* Search */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
            <input
              type="text"
              placeholder="Search templates..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full sm:w-64"
            />
          </div>

          {/* Action Buttons */}
          <div className="flex gap-2">
            <button
              onClick={onRefresh}
              disabled={isLoading}
              className="flex items-center gap-2 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              title="Refresh templates"
            >
              <RefreshCw
                className={`h-4 w-4 ${isLoading ? "animate-spin" : ""}`}
              />
              Refresh
            </button>

            <button
              onClick={onShowPreBuilt}
              className="flex items-center gap-2 px-4 py-2 text-purple-600 bg-purple-50 rounded-lg hover:bg-purple-100 transition-colors"
            >
              <Sparkles className="h-4 w-4" />
              Pre-built Templates
            </button>

            <button
              onClick={onCreateTemplate}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Plus className="h-4 w-4" />
              Create Template
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatesHeader;
